import React, { Component } from "react";
import NewNavBar from "./NewNavBar";
import LocalizedStrings from "../../localization/ProductionAssistLandingPage";
import "./newlandingpage.css"
import IMG_ROADMAP from "../../content/img/desktop-roadmapgraphic.png";
import IMG_IPAD_STRUCTURAL from "../../content/img_new/iPad_Structural.png";
import IMG_MOBILE_CLIP_STRUCTURAL from "../../content/img_new/infoclip_Structural.png";
import IMG_MOBILE_CLIP_ELECTRICAL from "../../content/img_new/mobile-infoclip_ELECTRICAL.png";
import IMG_MOBILE_CLIP_VR from "../../content/img_new/mobile-infoclip_VR.png";
import IMG_IPAD_VR from "../../content/img_new/iPad_VR.png";
import IMG_SCREEN_ELECTRICAL from "../../content/img_new/Screen_Electrical.png";
import IMG_PARTNER from "../../content/img/partnerlist.png";
import IMG_LIGHT_BLUE_BOX from "../../content/img/testimonialbox_lightblue.png";
import IMG_WHITE_BOX from "../../content/img/testimonialbox_white.png";
import IMG_SKY_BLUE_BOX from "../../content/img/testimonialbox_skyblue.png";
import IMG_DARK_BLUE_BOX from "../../content/img/testimonialbox_darkblue.png";
import IMG_MOBILE_HERO from "../../content/img/mobile-herographic.png";
import IMG_MOBILE_ROADMAP from "../../content/img/mobile-roadmapgraphic.png";
import IMG_RIGHT from "../../content/img/newright.png";
import IMG_LEFT from "../../content/img/newleft.png";
import IMG_PARTNERLOGOS from "../../content/img/partners-mobile.png";

import IMG_AYKE from "../../content/img_new/ayke.jpg";
import IMG_ERIK from "../../content/img_new/erik.jpg";
import IMG_MERIC from "../../content/img_new/meric.jpg";
import IMG_MARTIN from "../../content/img_new/martin.jpg";
import IMG_DIRK from "../../content/img_new/dirk.jpg";
import IMG_MAHLER_LOGO from "../../content/img/mahler_logo.png";

import NewFooter from "../WebComponents/NewFooter";
import { Link } from "react-router-dom";


class NewProductionAssistLandingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
          currentSlide: 0
        };
        this.commentsContainerRef = React.createRef();
    }

    handleClick = (direction) => {
        const comments = document.querySelector(".comments");
    
        if (comments) {
            const item = comments.querySelector(".comment");
            if (item) {
                const itemWidth = item.offsetWidth;
                if (direction === "previous") {
                    comments.scrollBy({ left: -itemWidth, behavior: "smooth" });
                } else {
                    comments.scrollBy({ left: itemWidth, behavior: "smooth" });
                }
            } else {
                console.error("No '.comment' elements found within the comments container.");
            }
        } else {
            console.error("Comments container not found.");
        }
    }

    render()
{
    return (
     <div  className="newlanding-page">
        <header>
            <NewNavBar />
            <div className="mainContent">
                <div className="mainHeading">
                    <p>{LocalizedStrings.StartPage_ApplicationArea}</p>
                    <h1 className="textsky">{LocalizedStrings.StartPage_Header}</h1>
                    <h1 className="textwhite">{LocalizedStrings.TheFutureOf}</h1>
                    <h1 className="textwhite">{LocalizedStrings.EventPlanning}</h1>
                    <Link to="/download"><button className="desktop-btn">{LocalizedStrings.CalloutQuickstart}</button></Link>
                    <Link to="/register"><button className="mobile-btn">{LocalizedStrings.RegisterNow}</button></Link>

                </div>
                <img className="hero" src={IMG_MOBILE_HERO} alt="hero" />
                <img className="mobile-hero" src={IMG_MOBILE_HERO} alt="mobile hero" />

            </div>

            <div className="roadmapcontainer">
                <h3 className="roadmap-start">{LocalizedStrings.Roadmap}</h3>
                <img className="roadmap desktop" src={IMG_ROADMAP} alt="road map" />
                 <img className="roadmap mobile" src={IMG_MOBILE_ROADMAP} alt="road map mobile" />

                <div className="roadmap-text">
                    <div>
                        <p>{LocalizedStrings.ElectricalPlanning}</p>
                        <p>{LocalizedStrings.ElectricalPlanningDetail1}</p>
                        <p>{LocalizedStrings.ElectricalPlanningDetail2}</p>

                    </div>

                    <div style={{color:"#20256b"}}>
                        <p>{LocalizedStrings.StructuralPlanning}</p>
                        <p>{LocalizedStrings.StructuralPlanningDetail}</p>
                    </div>
                    
                    <div style={{color:"#b1cdff"}}>
                        <p>{LocalizedStrings.Documentation}</p>
                        <p>{LocalizedStrings.DocumentationDetail}</p>
                    </div>

                    <div style={{color:"#1e6fff"}}>
                        <p>{LocalizedStrings.Engineering}</p>
                        <p>{LocalizedStrings.EngineeringDetail}</p>
                    </div>

                </div>
            </div>

        
        </header>

        <div className="info">
            <section className="structuralAnalysis">
                <div className="content">
                    <h4>{LocalizedStrings.StructuralAnalysisRedefined}</h4>
                    <h2 className="infoHeader">{LocalizedStrings.ElevateSafety}</h2>
                    <h2 className="infoHeader">{LocalizedStrings.AndDesign}</h2>
                    <p className="desktop">{LocalizedStrings.Structural_text1}</p>
                    <p className="desktop">{LocalizedStrings.Structural_text2}</p>
                    <p className="mobile-p">{LocalizedStrings.Structural_mobile}</p>
                    <div className="btn-group-desktop">
                        <Link to="/download"><button className="btn orange-btn">{LocalizedStrings.Header_Download}</button></Link>
                        <Link to="/static"><button className="btn grey-btn">{LocalizedStrings.Summery_Learn_More}</button></Link>
                        <Link to="/static-office"><button style={{width: "max-content"}} className="btn grey-btn">{LocalizedStrings.VisitEngineeringOffice}</button></Link>

                    </div>
                </div>
                <img className="desktop" src={IMG_IPAD_STRUCTURAL} alt="structural img" />
                <img className="mobile" src={IMG_MOBILE_CLIP_STRUCTURAL} alt="mobile clip" />
            </section>

            <section className="electrical">
                <img className="desktop" src={IMG_SCREEN_ELECTRICAL} alt="electrical img" />
                <div className="content">
                    <h4 className="desktop">{LocalizedStrings.ElectricalExcellence}</h4>
                    <h4 className="desktop">{LocalizedStrings.Signal}</h4>
                    <h4 className="mobile">{LocalizedStrings.ElectricalExcellenceSignal}</h4>
                    <h2 className="infoHeader">{LocalizedStrings.Streamline}</h2>
                    <h2 className="infoHeader">{LocalizedStrings.YourSetup}</h2>
                    <p className="desktop">{LocalizedStrings.Electrical_text1}</p>
                    <p className="desktop">{LocalizedStrings.Electrical_text2}</p>
                    <p className="mobile-p">{LocalizedStrings.Electrical_mobile}</p>

                    <div className="btn-group-desktop">
                        <Link to="/download"><button className="btn orange-btn">{LocalizedStrings.Header_Download}</button></Link>
                        <Link to="/powerPlanning"><button className="btn grey-btn">{LocalizedStrings.Summery_Learn_More}</button></Link>
                    </div>
                </div>
                <img className="mobile" src={IMG_MOBILE_CLIP_ELECTRICAL} alt="mobile clip" />
    
            </section>

            <section className="vision">
                <div className="content">
                    <h4>{LocalizedStrings.VisionReality}</h4>
                    <h2 className="infoHeader">{LocalizedStrings.AdvancedPlanning}</h2>
                    <h2 className="infoHeader">{LocalizedStrings.AndDocumentation}</h2>
                    <p className="desktop">{LocalizedStrings.Vision_text1}</p>
                    <p className="desktop">{LocalizedStrings.Vision_text2}</p>
                    <p className="mobile-p">{LocalizedStrings.Vision_mobile}</p>

                    <div className="btn-group-desktop">
                        <Link to="/download"><button className="btn orange-btn">{LocalizedStrings.Header_Download}</button></Link>
                        <Link to="/vrLanding"><button className="btn grey-btn">{LocalizedStrings.Summery_Learn_More}</button></Link>
                    </div>
                </div>
                <img className="desktop" src={IMG_IPAD_VR} alt="vision img" />
                <img className="mobile" src={IMG_MOBILE_CLIP_VR} alt="mobile clip" />

            </section>
            
            <section className="trust">
                <h2>{LocalizedStrings.TrustByTheBest}</h2>

                <img src={IMG_LEFT} alt="slider left" class="mobile left" onClick={() => this.handleClick('previous')}/>
                <div className="comments">
                    <div className="comment textdark">
                        <img className="box" src={IMG_LIGHT_BLUE_BOX} alt="lightblue" />
                        <img className="avatar" src={IMG_MERIC} alt="ayke" />

                        <div className="comment-content">
                            <p className="bold">Méric Messahli</p>
                            <p>{LocalizedStrings.Position1}</p>
                            <p className="quote textwhite">,,</p>
                            <p>{LocalizedStrings.Comment_text1}</p>
                        </div>
                    </div>

                    <div className="comment textwhite mahler">
                        <img className="box" src={IMG_SKY_BLUE_BOX} alt="skyblue" />
                        <img className="k-logo" src={IMG_MAHLER_LOGO} alt="mahler logo" />
                        <div className="cover"></div>
                        <img className="avatar" src={IMG_DIRK} alt="dirk" />
                        <div className="comment-content">
                            <p className="bold">Dirk Niemeyer</p>
                            <p>Diplom-Ingenieur</p>
                            <p className="quote textdark">,,</p>
                            <p>{LocalizedStrings.Comment_fromDirkNiemeyer}</p>
                        </div>
                    </div>
                    
                    <div className="comment textsky">
                        <img className="box" src={IMG_WHITE_BOX} alt="darkblue" />
                        <img className="avatar" src={IMG_ERIK} alt="ayke" />
                        <div className="comment-content">
                            <p className="bold">Eric Warden</p>
                            <p>Director, Rigging Infrastructure</p>
                            <p className="quote">,,</p>
                            <p>{LocalizedStrings.Comment_text4}</p>
                        </div>
                    </div>

                    <div className="comment textwhite">
                        <img className="box" src={IMG_SKY_BLUE_BOX} alt="skyblue" />
                        <img className="avatar" src={IMG_MARTIN} alt="ayke" />
                        <div className="comment-content">
                            <p className="bold">Martin Fruck</p>
                            <p>Quality Control Manager</p>
                            <p className="quote textdark">,,</p>
                            <p>{LocalizedStrings.Comment_text3}</p>
                        </div>
                    </div>

                    <div className="comment textgrey">
                        <img className="box" src={IMG_DARK_BLUE_BOX} alt="white" />
                        <img className="avatar" src={IMG_AYKE} alt="ayke" />
                        <div className="comment-content">
                            <p className="bold">Ayke Edelmat</p>
                            <p>Owner</p>
                            <p className="quote textsky">,,</p>
                            <p>{LocalizedStrings.Comment_text2}</p>
                        </div>
                    </div>
                </div>
                <img src={IMG_RIGHT} alt="slider right" class="mobile right" onClick={() => this.handleClick('next')}/>
            </section>

            <section className="partner">
                <h2>{LocalizedStrings.WhoIsUsingIt}</h2>
                <div className="company">
                    <img className="desktop" src={IMG_PARTNER} alt="partner" />
                    <img className="mobile" src={IMG_PARTNERLOGOS} alt="partner logo" />
                </div>
            </section>
        </div>
        <NewFooter />

     </div>) 
}
}

export default NewProductionAssistLandingPage;
